// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vuei18n from 'vue-i18n'
import router from './router'
import http from './utils/http'
import store from './stores'
import filters from './filters'
import { getCookie } from './utils/auth'
import en from './lang/en'
import zh from './lang/zh'
import './styles/common.css'
import './styles/common_fm.css'
import './styles/element-ui.scss'
import './styles/common_user.scss'

Vue.config.productionTip = false
Vue.prototype.$http = http
Vue.use(Vuei18n)
// vue-il8n中补充element-ui的语言包
const i18n = new Vuei18n({
  // locale: getCookie('iot-lang') || 'zh',
  locale: window.localStorage.hasOwnProperty('iot-lang') ? window.localStorage.getItem('iot-lang') : 'zh',
  messages: {
    zh: {
      ...zh,
      ...ELEMENT.lang.zhCN
    },
    en: {
      ...en,
      ...ELEMENT.lang.en
    }
  }
})
Vue.use(ELEMENT, {
  i18n: (key, value) => i18n.t(key, value)
})
Object.keys(filters).forEach(key => Vue.filter(key, filters[key]))
router.beforeEach((to, from, next) => {
  if (to.meta.title) { // 页面标题
    document.title = i18n.t(to.meta.title)
  } else {
    document.title = i18n.t('router.title')
  }
  let routerName = to.name
  // 已登录时跳转至 登录/注册页时， 重定向
  if (to.path === '/signin' || to.path === '/signup') {
    console.log('from-path', from.path)
    const nextPath = from.path || '/'
    if (getCookie('iot-session')) {
      next({ path: nextPath })
    } else {
      next()
    }
  } else {
    if (to.meta.needPermission) {
      if (getCookie('iot-session')) {
        next()
      } else if (to.meta.noRedirect) {
        next({
          path: '/signin'
        })
      } else {
        routerName = 'signin'
        next({
          path: '/signin',
          query: {
            redirect: to.fullPath
          }
        })
      }
    } else {
      next()
    }
  }
  // 在store-routers中存储routerName， 以区分当前所在页面，用于菜单显示active状态
  store.dispatch('setRouterName', routerName)
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js